import * as React from 'react';

const Us24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 18, height: 12, x: 3, y: 6, fill: "#CB001C", rx: 2 }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#F1F2F1",
    d: "M20.989 16.15H3c.025.337.133.65.304.92h17.38c.172-.27.28-.583.305-.92M3 15.231h18v-.92H3zm0-1.851h18v-.92H3zm8-1.84h10v-.92H11zm0-1.85h10v-.92H11zm9.678-2.77h-9.684v.92h9.994a2 2 0 0 0-.31-.92"
  }
), /* @__PURE__ */ React.createElement("path", { fill: "#2A3560", d: "M3 12.46h8V6H5a2 2 0 0 0-2 2z" }));
Us24.Size = 24;
Us24.Title = "Us";

export { Us24 as default };
